baseApp.directive('ruler', function() {
	return {
		templateUrl: '/public/directives/ruler.html',
		scope: {
			from: '=',
			to: '=',
			minInterval: '=?',
			dataUpdate: '=',

		},
		controller: ['$scope', '$timeout', function($scope, $timeout) {
			$scope.rulerId = 'ruler_' + $scope.$id;
			var rulerChart = null;
			var DEFAULT_MIN_PERIOD = "2500fff";
			var updateTimeout = null;

			$scope.$on('updateRuler', function() {
				if (updateTimeout) {
					$timeout.cancel(updateTimeout);
				}
				updateTimeout = $timeout(function() {
					updateRuler();
				}, 1, false);
			});

			function updateRuler() {
				if ((!$scope.from && $scope.from !== 0) || (!$scope.to && $scope.to !== 0)) {
					return;
				}

				var data = [
					{
						value: 0,
						time: $scope.from
					},
					{
						value: 0,
						time: $scope.to
					}
				];

				if(rulerChart){
					rulerChart.dataProvider = data;
					rulerChart.valueAxes[0].minimumDate = $scope.from;
					rulerChart.valueAxes[0].maximumDate = $scope.to;
					rulerChart.validateData();
				}
				else {
					rulerChart = AmCharts.makeChart($scope.rulerId, {
						"type": "serial",
						fontFamily: 'Roboto',
						addClassNames: true,
						"path": "/public/javascripts/external/amcharts/",
						"pathToImages": "/public/javascripts/external/amcharts/images/",
						"categoryField": "time",
						theme: "new",
						autoMargins: false,
						marginTop: 0,
						marginBottom: 30,
						marginLeft: 0,
						marginRight: 0,
						"categoryAxis":{
							gridAlpha: 0.15,
							"minPeriod": $scope.minInterval || DEFAULT_MIN_PERIOD,
							markPeriodChange: true,
							"parseDates": true,
							centerLabelOnFullPeriod: false,
							dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]
						},
						"graphs":  [{
							"fillAlphas": 1,
							"lineAlpha": 0.2,
							"type": "column",
							"valueField": "value"
						}],
						"guides": [],
						"dataProvider": data,
						valueAxes: [{
							maximum: 0,
							minimum: 0,
							minimumDate: $scope.startTime,
							maximumDate: $scope.endTime
						}]
					} );
				}
			}

			$timeout(function() {
				updateRuler();
			}, 0);

			$scope.$on('$destroy',function() {
				if (rulerChart) {
					rulerChart.clear();
					rulerChart = null;
				}

				if (updateTimeout) {
					$timeout.cancel(updateTimeout);
				}
			});
		}]
	}
});